export default {
    empty: "Nada a aprovar",
    saved: "Aprovações enviadas",
    review: "Revise e edite o centro de custo se estiver incorreto",
    message: {
        message: "Observação: todos os itens disponíveis no site O-I Peripherals serão cobrados de forma cruzada no seu orçamento/centro de custo. Como gerente aprovador, pedimos que você considere cuidadosamente cada solicitação e aprove somente quando o item for necessário para que seu funcionário conclua suas responsabilidades de trabalho."
    },
    card: {
        name: {
            label: "Nome"
        },
        date: {
            label: "Data"
        },
        details: {
            label: "Detalhes"
        },
        price: {
            label: "Preço"
        },
        manager: {
            label: "Gerente"
        },
        requested: {
            label: "Solicitado por"
        },
        history: {
            cta: {
                load: "Aprovações prévias",
                loading: "Carregando",
                show: "Aprovações prévias",
                hide: "Aprovações prévias"
            },
            approvals: {
                empty: "Nenhuma aprovação prévia",
                item: {
                    status: {
                        approver: "por {approver}",
                        system: "Central de Ajuda",
                        approved: "Aprovado",
                        rejected: "Não aprovado",
                        unrequired: "Aprovação não necessária",
                        reason: "Razão",
                        transferred: "Transferido"
                    }
                }
            }
        },
        reason: {
            label: "Razão",
            placeholder: "Preencha o motivo"
        },
        cta: {
            approve: {
                cta: "Aprovar",
                processing: "Salvando"
            },
            disapprove: {
                cta: "Não aprovar",
                processing: "Salvando"
            }
        },
        saved: "Aprovações enviadas"
    }
}